export const GET_GROUP_LIST = 'GET_GROUP_LIST';
export const SET_GROUP_LIST = 'SET_GROUP_LIST';
export const SAVE_GROUP_APPLICATION_ACCESS = 'SAVE_GROUP_APPLICATION_ACCESS';
export const DELETE_GROUP_APPLICATION_ACCESS = 'DELETE_GROUP_APPLICATION_ACCESS';
export const SAVE_GROUP_CONFIG = 'SAVE_GROUP_CONFIG';
export const GET_GROUP_APPLICATION_ACCESS_LIST = 'GET_GROUP_APPLICATION_ACCESS_LIST';
export const SET_GROUP_APPLICATION_ACCESS_LIST = 'SET_GROUP_APPLICATION_ACCESS_LIST';
